const wrapperElementsNodes = document.querySelectorAll('.js-pulldown-wrapper');
const $wrapperElements = Array.prototype.slice.call(wrapperElementsNodes, 0);

const pulldown = ($wrapper) => {
  const $elements = {
    trigger: $wrapper.querySelector('.js-pulldown-trigger'),
    target: $wrapper.querySelector('.js-pulldown-target')
  };

  const zIndex = 100;

  function addTargetToZIndex () {
    $elements.target.style.zIndex = zIndex + 1;
  }

  function createOverlay () {
    const div = document.createElement('div');
    div.classList.add('js-pulldown-background');
    div.style.cssText = `position:fixed;z-index:${zIndex};width:100%;height:100%;left:0;top:0;`;
    return div;
  }

  function addEventToOverlay ($overlay) {
    $overlay.addEventListener('click', () => {
      handleClose($overlay);
    });
  }

  function addOverlay () {
    const $overlay = createOverlay();
    $wrapper.insertBefore($overlay, $elements.target);
    addEventToOverlay($overlay);
  }

  function handleClose ($overlay) {
    $overlay.parentNode.removeChild($overlay);
    $elements.target.classList.remove('active');
  }

  function handleOpen () {
    $elements.target.classList.add('active');
    addOverlay();
    addTargetToZIndex();
  }

  function addEvent () {
    $elements.trigger.addEventListener('click', () => {
      handleOpen();
    });
  }

  function init () {
    addEvent();
  }

  init();
};

window.addEventListener('DOMContentLoaded', () => {
  if ($wrapperElements !== null) {
    $wrapperElements.forEach(el => {
      pulldown(el);
    });
  }
});
